﻿import { Outlet } from 'react-router';
// @mui
import { styled } from '@mui/material/styles';
// components
import Logo, { LogoProps } from '../components/Logo';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const HeaderStyle = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0)
  }
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  return (
    <>
      <HeaderStyle>
        <Box sx={{ width: 0.8, display: 'flex', ml: 11, alignItems: 'center', height: 1 }}>
          <Logo disabledLink={false} color={LogoProps.LIGHT} />
        </Box>
      </HeaderStyle>
      <Outlet />
    </>
  );
}
